import React, { useEffect } from "react";
import { connect } from "react-redux";
import { generateDCFValuation } from "../../../../store/modules/dealOffer/actions";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import YearBar from "../YearBar";
import Subtitle from "../Subtitle";
import Item from "../Item";

function DCFValuation({
  dealType,
  dealDCFValuation,
  dispatchGenerateDCFValuation,
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateDCFValuation(dealType);
  }, []);

  return (
    <div>
      {dealDCFValuation?.debtMetrics &&
        (<div className="pt-5">

          <YearBar data={dealDCFValuation.yearsFormatted} />

          <Subtitle title="Discounted Free Cash Flow to Equity Holders" length={dealDCFValuation.yearsFormatted.length} />
          <Item name="Free Cash Flow to Equity Holders" data={dealDCFValuation.FCFE} />
          <Item name="Terminal Value" data={dealDCFValuation.terminalValue} />
          <Item name="Total Free Cash Flow" data={dealDCFValuation.totalFCFE} bold={true} />
          <Item name="Cumulative Cash Flows" data={dealDCFValuation.cumulativeCashFlows} />
          <Item name="Present Value Factor" data={dealDCFValuation.PVFactor} endLabel=" " />
          <Item name="NPV from First Principal" data={dealDCFValuation.NPVfromFirstPrincipal} bold={true} />

          <Subtitle title="Debt Ratios" length={dealDCFValuation.yearsFormatted.length} />
          <Item name="Total Debt / EBITDA" data={dealDCFValuation.debtToEBITDA} endLabel="x" />
          <Item name="Total Debt / EBIT" data={dealDCFValuation.debtToEBIT} endLabel="x" />
          <Item name="EBITDA / Interest & Principal" data={dealDCFValuation.EBITDAToRepayment} endLabel="x" />
          <Item name="EBIT / Interest & Principal" data={dealDCFValuation.EBITToRepayment} endLabel="x" />

          <Subtitle title="Debt Metrics" length={dealDCFValuation.yearsFormatted.length} />
          <div className="flex items-center mt-2 font-semibold">
            <div className="flex items-center" style={{ minWidth: "18em" }} />
            <div className="mr-2 text-center" style={{ width: "10em" }}>IRR</div>
            <div className="mr-2 text-center" style={{ width: "10em" }}>EM</div>
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>Line of Credit</div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.debtMetrics.lineOfCredit.IRR} size="small" endAdornment endAdornmentLabel="%" disabled />
            </div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.debtMetrics.lineOfCredit.EM} size="small" endAdornment endAdornmentLabel="x" disabled />
            </div>
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>Owner Financing</div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.debtMetrics.ownerFinancing.IRR} size="small" endAdornment endAdornmentLabel="%" disabled />
            </div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.debtMetrics.ownerFinancing.EM} size="small" endAdornment endAdornmentLabel="x" disabled />
            </div>
          </div>
          {dealDCFValuation.debtMetrics.otherDebtsArray?.map((debt) => (
            <div className="flex items-center mt-2">
              <div className="flex items-center" style={{ minWidth: "18em" }}>{debt.name}</div>
              <div className="flex mr-2" style={{ width: "10em" }}>
                <BVAInput value={debt.IRR} size="small" endAdornment endAdornmentLabel="%" disabled />
              </div>
              <div className="flex mr-2" style={{ width: "10em" }}>
                <BVAInput value={debt.EM} size="small" endAdornment endAdornmentLabel="x" disabled />
              </div>
            </div>
          ))}

          {/* <Subtitle title="Equity Value" length={dealDCFValuation.yearsFormatted.length} />
          <div className="flex items-center mt-2 font-semibold">
            <div className="flex items-center" style={{ minWidth: "18em" }} />
            <div className="mr-2 text-center" style={{ width: "10em" }}>Start Year</div>
            <div className="mr-2 text-center" style={{ width: "10em" }}>Exit Year</div>
          </div>
          <div className="flex items-center mt-2 font-semibold">
            <div className="flex items-center" style={{ minWidth: "18em" }}>Enterprise Value</div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.enterpriseValue} size="small" startAdornment startAdornmentLabel="$" disabled />
            </div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.enterpriseValue} size="small" startAdornment startAdornmentLabel="$" disabled />
            </div>
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>(+) Cash</div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.startCash} size="small" startAdornment startAdornmentLabel="$" disabled />
            </div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.endCash} size="small" startAdornment startAdornmentLabel="$" disabled />
            </div>
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>(+) Marketable Securities</div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.securities} size="small" startAdornment startAdornmentLabel="$" disabled />
            </div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.securities} size="small" startAdornment startAdornmentLabel="$" disabled />
            </div>
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>(-) Debt</div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.startDebt} size="small" startAdornment startAdornmentLabel="$" disabled />
            </div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.endDebt} size="small" startAdornment startAdornmentLabel="$" disabled />
            </div>
          </div>
          <div className="flex items-center mt-2 font-semibold">
            <div className="flex items-center" style={{ minWidth: "18em" }}>Equity Value</div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.startEquityValue} size="small" startAdornment startAdornmentLabel="$" disabled />
            </div>
            <div className="flex mr-2" style={{ width: "10em" }}>
              <BVAInput value={dealDCFValuation.endEquityValue} size="small" startAdornment startAdornmentLabel="$" disabled />
            </div>
          </div> */}

          <Subtitle title="Financial Metrics" length={dealDCFValuation.yearsFormatted.length} />
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>XNPV</div>
            <BVAInput value={dealDCFValuation.enterpriseValue} size="small" width="10em" endAdornment endAdornmentLabel="$" disabled />
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>XIRR</div>
            <BVAInput value={dealDCFValuation.XIRR} size="small" width="10em" endAdornment endAdornmentLabel="%" disabled />
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>MIRR</div>
            <BVAInput value={dealDCFValuation.MIRR} size="small" width="10em" endAdornment endAdornmentLabel="%" disabled />
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>Equity Multiple</div>
            <BVAInput value={dealDCFValuation.cashOnReturn} size="small" width="10em" endAdornment endAdornmentLabel="x" disabled />
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>Percentage Terminal Value</div>
            <BVAInput value={dealDCFValuation.percentTV} size="small" width="10em" endAdornment endAdornmentLabel="%" disabled />
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>Percentage Annual Cashflows</div>
            <BVAInput value={dealDCFValuation.percentAC} size="small" width="10em" endAdornment endAdornmentLabel="%" disabled />
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>Payback Period</div>
            <BVAInput value={dealDCFValuation.payback} size="small" width="10em" endAdornment endAdornmentLabel="Years" disabled />
          </div>
          <div className="flex items-center mt-2">
            <div className="flex items-center" style={{ minWidth: "18em" }}>Profitability Index</div>
            <BVAInput value={dealDCFValuation.profitability} size="small" width="10em" endAdornment endAdornmentLabel="x" disabled />
          </div>

        </div>)
      }
    </div>
  );
}

const mapStateToProps = (state) => ({
  dealDCFValuation: state.dealOffer.dealDCFValuation,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateDCFValuation(dealType) {
    await dispatch(generateDCFValuation(dealType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DCFValuation);
